/**
 * HOS API
 *
 *
 * OpenAPI spec version: 1.0
 * Contact: info@bayinteractive.com
 *
 */
import {Injectable, Injector} from "@angular/core";
import {HosBaseService} from "./hos-base.service";

import {HttpResponse, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import { map } from 'rxjs/operators';
import "../rxjs-operators";
import {AppConstants} from "../../app.constants";
import {PeopleFeedback} from "../model/PeopleFeedback";
import {Page} from '../model/generic/page';

/* tslint:disable:no-unused-variable member-ordering */


@Injectable()
export class PeopleFeedbackService extends HosBaseService {

  constructor(injector: Injector) {
    super(injector);
  }

  /**
   * Return the peopleFeedback
   *
   */
  public getPeopleFeedback(page?: number, size?: number, extraHttpRequestParams?: any): Observable<Page<PeopleFeedback>> {
    return this.getPeopleFeedbackWithHttpInfo(page, size, extraHttpRequestParams)
      .pipe(
        map((response) => {
          if (response.status === 204) {
            return undefined;
          } else {
            return response.body;
          }
        })
      );
  }

  /**
   * Return the peopleFeedback
   *
   */
  public getPeopleFeedbackWithHttpInfo(page?: number, size?: number, extraHttpRequestParams?: any): Observable<HttpResponse<Page<PeopleFeedback>>> {
    const path = this.getBasePath() + `/people-feedback`;

    let queryParameters = new HttpParams();
    let headers = this.getNoLoginHeaders();

    if (page !== undefined) {
      queryParameters = queryParameters.set('page', <any>page);
    }
    if (size !== undefined) {
      queryParameters = queryParameters.set('size', <any>size);
    }

    // to determine the Accept header
    let produces: string[] = [
      'application/json'
    ];


    let requestOptions = {
      headers: headers,
      params: queryParameters
    };

    // https://github.com/swagger-api/swagger-codegen/issues/4037
    if (extraHttpRequestParams) {
      requestOptions = this.extendObj(requestOptions, extraHttpRequestParams);
    }

    return this.executeHttpRequest(AppConstants.RequestMethods.GET, path, requestOptions);
  }

}
